import makeStyles from '@mui/styles/makeStyles';
import {useSetTranslation} from "common/useSetTranslation";
import Dialog from "components/redesign/Dialog";
import {get, isEmpty} from "lodash";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {color, font, match, type} from "common/tokens";

const useStyles = makeStyles(theme => ({
  title: {
    ...type.pageTitle,
    color: color.TEXT,
    margin: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: 24,
      lineHeight: '30px',
    },
  },
  countdown: {
    marginTop: 8,
    ...type.meta,
    fontWeight: font.BOLD,
    color: match.STATUS_OPEN,
  },
  link: {
    appearance: 'none',
    background: 'none',
    border: 0,
    padding: 0,
    marginTop: 8,
    cursor: 'pointer',
    ...type.meta,
    fontWeight: font.SEMIBOLD,
    color: color.ACCENT_TEXT,
  },
  sheetText: {
    ...type.body,
    color: color.TEXT_MUTED,
  },
}));

export const useMatchingCopy = listDetail => {
  const {st} = useSetTranslation();

  return {
    title: st(get(listDetail, 'title'), get(listDetail, 'localeTitle')),
    description: st(get(listDetail, 'description'), get(listDetail, 'localeDescription')),
  };
};

const MatchingScreenIntro = ({listDetail, fallbackTitle, countdown, showDescription = 'link'}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const [open, setOpen] = useState(false);

  const {title, description} = useMatchingCopy(listDetail);
  const heading = isEmpty(title) ? fallbackTitle : title;

  return (
    <div>
      <div className={classes.title}>{heading}</div>
      {!isEmpty(countdown) && <div className={classes.countdown}>{countdown}</div>}

      {showDescription === 'link' && !isEmpty(description) && (
        <>
          <button type={'button'} className={classes.link} onClick={() => setOpen(true)}>
            {`${t('moreInfo')} →`}
          </button>
          {open && (
            <Dialog open onClose={() => setOpen(false)} title={heading} maxWidth={520}>
              <div className={classes.sheetText}>{description}</div>
            </Dialog>
          )}
        </>
      )}
    </div>
  );
};

export default MatchingScreenIntro;
